import { ImgHTMLAttributes } from 'react';
import WarrantyPromo from 'components/Article/content/WarrantyPromo';
import ContentAd from 'components/Ad/ContentAd';

export interface AdProps {
  value: string;
}

export function Ad({ value }: AdProps): JSX.Element {
  return value === 'warrantyPromo' ? <WarrantyPromo /> : <ContentAd adType={value} />;
}

export function Image(props: ImgHTMLAttributes<unknown>): JSX.Element {
  return <img {...props} loading="lazy" />;
}

export default {
  ad: Ad,
  image: Image,
};
